import * as yup from 'yup';

export const commentSchema = yup.object().shape({
    comment: yup.string()
        .required()
        .min(3, 'O comentário deve possuir mais que 3 caracteres.')
});


export type CommentFormData = {
    comment: string;
}